<ng-diagram-base-node-template [node]="node()">
    <span class="avs-node-label">{{ node().data.label }}</span>
</ng-diagram-base-node-template>

<ng-diagram-port id="port-bottom" type="both" side="bottom" />
<ng-diagram-port id="port-top" type="both" side="top" />
